module.exports = __webpack_public_path__ + "main-logged-out-58e5f421/signup-layer-illustration-9f6e803ff5ddcbf4094d3e1185fb834c.svg";